import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response, XHRBackend } from '@angular/http';
import { AuthService } from '../user/auth.service';
import { HttpService } from '../../modules/UIKit/components/spinnerLoading/httpServ.service';
import { ResponseHandlerService } from './responseHandler.service';
import { Observable } from 'rxjs/Observable';
import { IdentificationService } from './identification.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { HttpParams } from '@angular/common/http';

/**
 * HttpClient with Bearer authentication
 */
@Injectable()
export class HttpClientService extends Http {

  public static readonly DATE_FORMAT = 'MMM D, YYYY h:mm:ss A';

  public static readonly BASE_MS_AUTH = '/koncentro-auth';
  public static readonly BASE_MS_COMMON = '/koncentro-common';
  public static readonly BASE_MS_ANALYTICS_CAMP = '/koncentro-analytics/campaign/';
  public static readonly BASE_MS_ANALYTICS = '/koncentro-analytics';
  public static readonly BASE_MS_CUSTOMERS = '/koncentro-customers';
  public static readonly BASE_MS_LOYALTY = '/koncentro-loyalty';
  public static readonly BASE_MS_CLUSTERING = '/koncentro-clustering';
  public static readonly BASE_MS_PROMO = '/koncentro-promo';
  public static readonly BASE_MS_API = '/koncentro-api';
  public static readonly BASE_MS_PROXY = '/koncentro-proxy';
  public static readonly BASE_MS_COUPON_MG_MANAGEMENT = '/api/kss/kss-kloy-coupon-service-management';
  public static readonly BASE_MS_COUPON_MG_LOG = '/api/kss/kss-kloy-coupon-service-log';
  public static readonly DEFAULT_ITEM_PER_PAGE = 10;

  private baseUrl = HttpClientService.BASE_MS_COMMON;

  protected refreshingToken = false;
  protected refreshCall;

  public static buildListParams(
    offset = null, limit = null, search?: Array<{ key: string, value: string }>,
    globalSearch?: string, sort?: string, sort_dir?: number, flg_state?: string
  ): HttpParams {
    let params: HttpParams = new HttpParams();
   
    if (search) {
      for (const filter of search) {
        if (filter.value) {
          params = params.set(filter.key, filter.value);
        }
      }
    }
    console.log("params before", params)
    if (sort) {
      params = params.set('sort', sort);
      params = params.set('sort_dir', sort_dir ? sort_dir.toString() : '1');
    }


    if (offset !== null) {
      params = params.set('offset', offset.toString());
    }
    if (limit !== null) {
      params = params.set('limit', limit.toString());
    }
    if (flg_state) {
      params = params.set('flg_state', flg_state);
    }
    console.log("params", params)
    return params;
  }

  constructor(
    backend: XHRBackend, defaultOptions: RequestOptions,
    protected h: HttpService,
    private authService: AuthService,
    private localeStorage: LocalStorageService,
    private srvResponse: ResponseHandlerService,
    private idService: IdentificationService
  ) {
    super(backend, defaultOptions);
    idService.caller = this;
  }
  // Create observer object
  createUploadHeader(headers) {
    headers.append('Accept', 'application/json');
  }
  createAuthorizationHeader(headers: Headers, url: string) {
    /*
    if (!this.authService.user) {
      if(this.localeStorage.get('userData') != null){
        this.authService.user = this.localeStorage.get('userData');
      }
      else if(sessionStorage.getItem('userData') != null){
        this.authService.user = JSON.parse(sessionStorage.getItem("userData"));
      }
    }
    */

    if (this.localeStorage.get('userData') != null) {
      this.authService.user = this.localeStorage.get('userData');
    }
    else if (sessionStorage.getItem('userData') != null) {
      this.authService.user = JSON.parse(sessionStorage.getItem("userData"));
    }

    if (this.authService.user && this.authService.user.token) {
      headers.append('Authorization', 'Bearer ' + this.authService.user.token);
    }
    if (this.authService.sessionHelper != null && this.authService.sessionHelper.selectedLanguage != null) {
      headers.append('Accept-Language', this.authService.sessionHelper.selectedLanguage);
    } else {
      headers.append('Accept-Language', 'en');
    }

    if (this.authService.user && this.authService.user.selectedCompany) {
      headers.append('Accept-Company', this.authService.user.selectedCompany.toString());
    } else {
      headers.append('Accept-Company', '0');
    }

    const uuidv1 = require('uuid/v1');
    const uuid = uuidv1();
    // console.log('UUID', uuid)

    if (url.includes('koncentro-api')) {
      headers.append('kapiuuid', uuid);
    } else {
      headers.append('kuuid', uuid);
    }


  }

  get(url, params?) {
    return this.getAdv(url, params);
  }
  post(url, data, silent?) {
    return this.postAdv(url, data, silent);
  }

  put(url, data) {
    return this.putAdv(url, data);
  }

  putSuccess(url, data) {
    return this.putSuccessAdv(url, data);
  }
  delete(url, body?) {
    return this.deleteAdv(url, body);
  }
  upload(url, data) {
    return this.uploadAdv(url, data);
  }
  getFileByByteArray(url, params?) {
    return this.getFileByByteArrayAdv(url, params);
  }

  /**
   * @param url
   * @param params
   * @param silent
   */
  getAdv(url, params?, silent = false) {
    let headers = new Headers();
    this.createAuthorizationHeader(headers, url);

    if (!this.refreshingToken) {
      return this.h.get(url, { headers: headers, params: params })
        .map((res) => {
          return this.srvResponse.handleOK(res);
        })
        .catch((res) => {
          return this.srvResponse.handleKO(res);
        })
        .do(
          res => { },
          err => {
            if (!silent) { this.srvResponse.displayErrors(err); }
          }
        );
    }

    return Observable.fromPromise(this.refreshCall).flatMap(() => {
      console.log('flat map');
      let headerz = new Headers();
      this.createAuthorizationHeader(headerz, url);
      return this.h.get(url, { headers: headerz })
        .map((res) => { return this.srvResponse.handleOK(res); })
        .catch((res) => { return this.srvResponse.handleKO(res); })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    });

  }
  get_KSS(url, params?, silent = false) {
    //utilizzato per i servizi kss (voucher & coupon gabrielli)
    let headers = new Headers();
    this.createAuthorizationHeader(headers, url);

    if (!this.refreshingToken) {
      return this.h.get(url, { headers: headers, params: params })
        .map((res) => {
          return this.srvResponse.handle_KSS_OK_GET(res);
        })
        .catch((res) => {
          return this.srvResponse.handle_KSS_KO(res);
        })
        .do(
          res => { },
          err => {
            if (!silent) { this.srvResponse.displayErrors(err); }
          }
        );
    }

    return Observable.fromPromise(this.refreshCall).flatMap(() => {
      console.log('flat map');
      let headerz = new Headers();
      this.createAuthorizationHeader(headerz, url);
      return this.h.get(url, { headers: headerz })
        .map((res) => { return this.srvResponse.handle_KSS_OK_GET(res); })
        .catch((res) => { return this.srvResponse.handle_KSS_KO(res); })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    });

  }

  getPaged(url, params?, silent = false) {

    let headers = new Headers();
    this.createAuthorizationHeader(headers, url);


    if (!this.refreshingToken) {
      return this.h.get(url, { headers: headers, params: params })
        .map((res) => {
          return this.srvResponse.handleOKPaged(res);
        })
        .catch((res) => {
          return this.srvResponse.handleKO(res);
        })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    }

    return Observable.fromPromise(this.refreshCall).flatMap(() => {
      console.log('flat map');
      let headerz = new Headers();
      this.createAuthorizationHeader(headerz, url);
      return this.h.get(url, { headers: headerz })
        .map((res) => { return this.srvResponse.handleOKPaged(res); })
        .catch((res) => { return this.srvResponse.handleKO(res); })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    });
  }
  getFileByByteArrayAdv(url, params?, silent = false) {
    let headers = new Headers();
    this.createAuthorizationHeader(headers, url);

    if (!this.refreshingToken) {
      return this.h.get(url, { headers: headers, params: params })
        .map((res) => {
          return this.srvResponse.handleGetFileOK(res);
        })
        .catch((res) => {
          return this.srvResponse.handleGetFileKO(res);
        })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    }

    return Observable.fromPromise(this.refreshCall).flatMap(() => {
      console.log('flat map');
      let headerz = new Headers();
      this.createAuthorizationHeader(headerz, url);
      return this.h.get(url, { headers: headerz })
        .map((res) => { return this.srvResponse.handleGetFileOK(res); })
        .catch((res) => { return this.srvResponse.handleGetFileKO(res); })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    });

  }


  /**
   * Come getPaged, ma con metodo POST, chiamata in caso di risultati paginati
   * per poter ottenere i metadata
   */
  postPaged(url, data, silent = false) {
    let headers = new Headers();
    this.createAuthorizationHeader(headers, url);

    if (!this.refreshingToken) {
      return this.h.post(url, data, { headers: headers })
        .map((res) => {
          return this.srvResponse.handleOKPaged(res);
        })
        .catch((res) => {
          return this.srvResponse.handleKO(res);
        })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    }


    return Observable.fromPromise(this.refreshCall).flatMap(() => {
      console.log('flat map');
      let headerz = new Headers();
      this.createAuthorizationHeader(headerz, url);
      return this.h.post(url, data, { headers: headerz })
        .map((res) => { return this.srvResponse.handleOKPaged(res); })
        .catch((res) => { return this.srvResponse.handleKO(res); })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    });
  }
  putPaged(url, data, silent = false) {
    let headers = new Headers();
    this.createAuthorizationHeader(headers, url);
    if (!this.refreshingToken) {
      return this.h.put(url, data, { headers: headers })
        .map((res) => {
          return this.srvResponse.handleOKPaged(res);
        })
        .catch((res) => {
          return this.srvResponse.handleKO(res);
        })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    }


    return Observable.fromPromise(this.refreshCall).flatMap(() => {
      console.log('flat map');
      let headerz = new Headers();
      this.createAuthorizationHeader(headerz, url);
      return this.h.post(url, data, { headers: headerz })
        .map((res) => { return this.srvResponse.handleOKPaged(res); })
        .catch((res) => { return this.srvResponse.handleKO(res); })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    });
  }

  postAdv(url, data, silent = false) {

    let headers = new Headers();
    this.createAuthorizationHeader(headers, url);
    if (!this.refreshingToken) {
      return this.h.post(url, data, { headers: headers })
        .map((res) => {
          return this.srvResponse.handleOK(res);
        })
        .catch((res) => {
          return this.srvResponse.handleKO(res);
        })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    }

    return Observable.fromPromise(this.refreshCall).flatMap(() => {
      console.log('flat map');
      let headerz = new Headers();
      this.createAuthorizationHeader(headerz, url);
      return this.h.post(url, data, { headers: headerz })
        .map((res) => { return this.srvResponse.handleOK(res); })
        .catch((res) => { return this.srvResponse.handleKO(res); })
        .do(
          res => { },
          err => { if (!silent && err) { this.srvResponse.displayErrors(err); } }
        );
    });
  }

  post_KSS(url, data, silent = false) {
    //utilizzato per i servizi kss (voucher & coupon gabrielli)
    let headers = new Headers();
    this.createAuthorizationHeader(headers, url);
    if (!this.refreshingToken) {
      return this.h.post(url, data, { headers: headers })
        .map((res) => {
          return this.srvResponse.handle_KSS_OK_POST(res);
        })
        .catch((res) => {
          return this.srvResponse.handle_KSS_KO(res);
        })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    }

    return Observable.fromPromise(this.refreshCall).flatMap(() => {
      console.log('flat map');
      let headerz = new Headers();
      this.createAuthorizationHeader(headerz, url);
      return this.h.post(url, data, { headers: headerz })
        .map((res) => { return this.srvResponse.handle_KSS_OK_POST(res); })
        .catch((res) => { return this.srvResponse.handle_KSS_KO(res); })
        .do(
          res => { },
          err => { if (!silent && err) { this.srvResponse.displayErrors(err); } }
        );
    });
  }

  putAdv(url, data, silent = false) {
    let headers = new Headers();
    this.createAuthorizationHeader(headers, url);
    if (!this.refreshingToken) {
      return this.h.put(url, data, { headers: headers })
        .map((res) => {
          return this.srvResponse.handleOK(res);
        })
        .catch((res) => {
          return this.srvResponse.handleKO(res);
        })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    }

    return Observable.fromPromise(this.refreshCall).flatMap(() => {
      console.log('flat map');
      let headerz = new Headers();
      this.createAuthorizationHeader(headerz, url);
      return this.h.put(url, data, { headers: headerz })
        .map((res) => { return this.srvResponse.handleOK(res); })
        .catch((res) => { return this.srvResponse.handleKO(res); })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    });
  }

  put_KSS(url, data, silent = false) {
    let headers = new Headers();
    this.createAuthorizationHeader(headers, url);
    if (!this.refreshingToken) {
      return this.h.put(url, data, { headers: headers })
        .map((res) => {
          return this.srvResponse.handle_KSS_OK_PUT(res);
        })
        .catch((res) => {
          return this.srvResponse.handle_KSS_KO(res);
        })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    }

    return Observable.fromPromise(this.refreshCall).flatMap(() => {
      console.log('flat map');
      let headerz = new Headers();
      this.createAuthorizationHeader(headerz, url);
      return this.h.put(url, data, { headers: headerz })
        .map((res) => { return this.srvResponse.handle_KSS_OK_PUT(res); })
        .catch((res) => { return this.srvResponse.handle_KSS_KO(res); })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    });
  }

  patch_KSS(url, data, silent = false) {
    let headers = new Headers();
    this.createAuthorizationHeader(headers, url);
    if (!this.refreshingToken) {
      return this.h.patch(url, data, { headers: headers })
        .map((res) => {
          return this.srvResponse.handle_KSS_OK_PATCH(res);
        })
        .catch((res) => {
          return this.srvResponse.handle_KSS_KO(res);
        })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    }

    return Observable.fromPromise(this.refreshCall).flatMap(() => {
      console.log('flat map');
      let headerz = new Headers();
      this.createAuthorizationHeader(headerz, url);
      return this.h.put(url, data, { headers: headerz })
        .map((res) => { return this.srvResponse.handle_KSS_OK_PATCH(res); })
        .catch((res) => { return this.srvResponse.handle_KSS_KO(res); })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    });
  }

  putSuccessAdv(url, data, silent = false) {
    let headers = new Headers();
    this.createAuthorizationHeader(headers, url);
    if (!this.refreshingToken) {
      return this.h.put(url, data, { headers: headers })
        .map((res) => {
          return this.srvResponse.handleOK_success(res);
        })
        .catch((res) => {
          return this.srvResponse.handleKO(res);
        })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    }

    return Observable.fromPromise(this.refreshCall).flatMap(() => {
      console.log('flat map');
      let headerz = new Headers();
      this.createAuthorizationHeader(headerz, url);
      return this.h.put(url, data, { headers: headerz })
        .map((res) => { return this.srvResponse.handleOK(res); })
        .catch((res) => { return this.srvResponse.handleKO(res); })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    });
  }

  deleteAdv(url, body?, silent = false) {
    let headers = new Headers();
    this.createAuthorizationHeader(headers, url);
    if (!this.refreshingToken) {
      return this.h.delete(url, { headers, body })
        .map((res) => {
          return this.srvResponse.handleOK(res);
        })
        .catch((res) => {
          return this.srvResponse.handleKO(res);
        })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    }

    return Observable.fromPromise(this.refreshCall).flatMap(() => {
      console.log('flat map');
      let headerz = new Headers();
      this.createAuthorizationHeader(headerz, url);
      return this.h.delete(url, { headers: headerz })
        .map((res) => { return this.srvResponse.handleOK(res); })
        .catch((res) => { return this.srvResponse.handleKO(res); })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    });
  }

  uploadAdv(url, data, silent = false) {

    let headers = new Headers();
    this.createAuthorizationHeader(headers, url);
    this.createUploadHeader(headers);
    if (!this.refreshingToken) {
      return this.h.post(url, data, { headers: headers })
        .map((res) => {
          return this.srvResponse.handleOK(res);
        })
        .catch((res) => {
          return this.srvResponse.handleKO(res);
        })
        .do(
          res => { },
          err => { if (!silent) { this.srvResponse.displayErrors(err); } }
        );
    }

    return Observable.fromPromise(this.refreshCall).flatMap(() => {
      console.log('flat map');
      let headerz = new Headers();
      this.createAuthorizationHeader(headerz, url);
      return this.h.post(url, data, { headers: headerz })
        .map((res) => { return this.srvResponse.handleOK(res); })
        .catch((res) => { return this.srvResponse.handleKO(res); })
        .do(
          res => { },
          err => { if (!silent && err) { this.srvResponse.displayErrors(err); } }
        );
    });
  }
}


/**
 * This service is needed by angular translate in order to get language
 */
@Injectable()
export class HttpClientServiceLang extends HttpClientService {
  get(url) {
    let headers = new Headers();
    this.createAuthorizationHeader(headers, url);
    if (!this.refreshingToken) {
      return this.h.get(url, { headers: headers }).map(this.handleLangResp);
    }


    return Observable.fromPromise(this.refreshCall).flatMap(() => {
      console.log('flat map');
      let headerz = new Headers();
      this.createAuthorizationHeader(headerz, url);
      return this.h.get(url, { headers: headerz }).map(this.handleLangResp);
    });
  }

  private handleLangResp(res) {
    let data = res.json();
    return new Response({
      body: JSON.stringify(data.rsp_data),
      status: res.status,
      url: res.url,
      headers: res.header,
      merge: res.merge
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/services/httpClient/httpclient.service.ts